// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const invRecipeCategoryId = (z.number());
export const invRecipeCategory = z.object({
    id: invRecipeCategoryId,
    name: z.string(),
});
export const invRecipeCategoryInitializer = z.object({
    id: invRecipeCategoryId.optional(),
    name: z.string(),
});
export const invRecipeCategoryMutator = z.object({
    id: invRecipeCategoryId.optional(),
    name: z.string().optional(),
});
//# sourceMappingURL=InvRecipeCategory.js.map